import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import {
  useEventListener,
  useMutationObserver,
  useActiveElement,
} from "@vueuse/core";
import AppModal from "@/components/AppModal.vue";
import TheFeedbackForm from "@/components/TheFeedbackForm.vue";

/** route info */

export default /*#__PURE__*/_defineComponent({
  __name: 'TheFloatButtons',
  setup(__props) {

const route = useRoute();

/** focused element */
const focused = useActiveElement();

/** whether to show jump button */
const showJump = ref(false);
/** whether to show feedback form button */
const showFeedback = ref(true);
/** whether to show feedback modal */
const showModal = ref(false);
/** how much to push buttons upward to make room for footer if in view */
const nudge = ref(0);

/** update data state */
async function update() {
  /** wait for rendering to finish */
  await nextTick();

  /** whether some kind of input/textbox/control focused */
  const controlFocused =
    focused.value && focused.value.matches("input, textarea");

  /** get dimensions of footer */
  const footerEl = document?.querySelector("footer");
  if (!footerEl) return;
  const footer = footerEl.getBoundingClientRect();

  /** show jump button if user has scrolled far down enough */
  showJump.value = !controlFocused && window.scrollY > window.innerHeight * 0.1;
  /** show feedback button if user not already on dedicated feedback page */
  showFeedback.value =
    !controlFocused && String(route.name || "").toLowerCase() !== "feedback";

  /** calculate nudge */
  nudge.value = Math.max(0, footer.height + window.innerHeight - footer.bottom);
}

/** jump to top of page */
function jump() {
  window.scrollTo(0, 0);
}

/** run update on: page load, route change, focused, scroll, resize, reflow, etc. */
onMounted(update);
watch(route, update, { deep: true });
watch(focused, update);
useEventListener(window, "scroll", update);
useEventListener(window, "resize", update);
useMutationObserver(document?.body, update, {
  subtree: true,
  childList: true,
});

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "float",
    style: _normalizeStyle({ bottom: nudge.value + 'px' })
  }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showJump.value)
          ? _withDirectives((_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              design: "circle",
              class: "button",
              icon: "angle-up",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (jump()))
            }, null, 512)), [
              [_directive_tooltip, 'Jump to top of page']
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showFeedback.value)
          ? _withDirectives((_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              design: "circle",
              class: "button",
              icon: "comment",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = true))
            }, null, 512)), [
              [_directive_tooltip, 'Give us feedback on this page!']
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(AppModal, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showModal).value = $event)),
      label: "Feedback form"
    }, {
      default: _withCtx(() => [
        _createVNode(TheFeedbackForm, { modal: true })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 4))
}
}

})